import React, { useState } from 'react';
import { faCheck, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from 'reactstrap';
//Components
import Stepper from '../../../components/Stepper/Stepper';
import MainCard from '../../../components/MainCard/MainCard';
import IdentificacaoRota from './components/IdentificacaoRota';
import ListaGeradores from './components/ListaGeradores';
import ContainerFichaRota from './components/ContainerFichaRota';
import Loading from '../../../components/Loading/Loading';

//Api
import rotaColeta_api from '../../../api/rotaColeta_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import { validarCampos, objCampo } from '../../../helpers/ValidadorDeCampos';

//Estado inicial para o estado de cadastro da rota de coleta/ ordem
function initialStateRotaColeta({ rota = null }) {


    return {
        id: rota ? rota.id : 0,
        descricao: rota ? rota.descricao : "",
        placaVeiculo: rota ? rota.placaVeiculo : "",
        fantasiaDestino: rota ? rota.fantasiaDestino : "",
        tbVeiculos_Id: rota ? rota.tbVeiculos_Id : "",
        tbDestinos_Id: rota ? rota.tbDestinos_Id : "",
        status: rota ? rota.status : "Ativo",
        codigoERP: "",
        dataAtualizacao: rota ? rota.dataAtualizacao : "",
        usuarioAtualizacao: rota ? rota.usuarioAtualizacao : "",
        geradores: rota ? rota.geradores : []
    }
}

export default function NovaRota({ permissao, rota = null, Manutencao = null, btnVoltar, ordemAvulsa }) {
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);
    //Estado de validação de campos
    const [errors, setErrors] = useState({});
    //Estado que guarda o passo ativo do cadastro/Edição
    const [activeStep, setActiveStep] = useState(1);
    //Controle da apresentação do formulario de cadastro/edição
    const [openFormListaGeradore, setOpenFormListaGeradores] = useState(false);
    const toggleFormListaGeradores = () => setOpenFormListaGeradores(!openFormListaGeradore);

    //Estado de controle dos dados da rota de coleta
    const [rotaColeta, setRotaColeta] = useState(initialStateRotaColeta({ rota }));

    const camposIdentificacao = [
        objCampo({ required: true, name: "descricao" }),
        objCampo({ required: true, name: "tbVeiculos_Id" }),
        objCampo({ required: true, name: "tbDestinos_Id" }),
        objCampo({ required: true, name: "status" }),
    ]
    const validarCamposIdentificacao = () => {

        const _errors = validarCampos(rotaColeta, camposIdentificacao);
        setErrors(_errors[0]);
        return _errors[1];
    }
    const validarListaDeGeradores = () => {
        if (rotaColeta.geradores.length === 0) {
            showMessage("Aviso", "Informe uma localidade ou gerador!", "info", null);
            return ["informe ao menos uma localidade"];
        }
        return [];
    }
    //Passos do cadastro/edição
    const steps = [
        { text: "Identificação da rota", icon: faPencilAlt, validateStep: validarCamposIdentificacao },
        { text: "Geradores", icon: faPencilAlt, validateStep: validarListaDeGeradores, btnAdicionar: toggleFormListaGeradores, btnAdicionarText: Manutencao && Manutencao.id ? "+ Adicionar coleta extraordinária" : null },
        { text: "Finalizar", icon: faCheck },
    ]
    const onSubmit = () => {
        setLoading(true);
        if (rota) {
            rotaColeta_api.Put(rotaColeta).then(response => {
                showMessage("Sucesso", "Rota de coleta atualizada com sucesso!", "success", btnVoltar);
            }).catch(e => {
                showMessage("Aviso", e.message, "error");
            }).finally(f => setLoading(false));
        } else {
            rotaColeta_api.Post(rotaColeta).then(response => {
                showMessage("Sucesso", "Rota de coleta adicionada com sucesso!", "success", btnVoltar);
            }).catch(e => {
                showMessage("Aviso", e.message, "error");
            }).finally(f => setLoading(false));
        }
    }
    //Retorna o conteudo do passo ativo
    const getSteps = () => {

        switch (activeStep) {
            case 1: {
                return (
                    <IdentificacaoRota campos={camposIdentificacao} errors={errors} setErrors={setErrors} rotaColeta={rotaColeta} setRotaColeta={setRotaColeta} ordemAvulsa={ordemAvulsa} idRotaOrdem={null} idRotaManutencao={null} />
                );
            }
            case 2: {
                return (
                    <ListaGeradores permissao={permissao} rotaColeta={rotaColeta} setRotaColeta={setRotaColeta} idRotaManutencao={null} openForm={openFormListaGeradore} setOpenForm={setOpenFormListaGeradores} />
                )
            }
            case 3: {
                return (
                    <ContainerFichaRota rotaColeta={rotaColeta} ordemAvulsa={ordemAvulsa} idRotaOrdem={null} idRotaManutencao={null} editar={(step) => setActiveStep(step)} />
                )
            }
        }
    }


    return (
        <MainCard btnVoltar={btnVoltar}>
            {loading && <Loading />}
            <Row className='mb-4'>
                <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
            </Row>
            <Stepper steps={steps} activeStep={activeStep} setActiveStep={setActiveStep} onSubmit={onSubmit}>
                {getSteps()}
            </Stepper>
        </MainCard >
    )
}